import { FormInput, PrimaryButton } from '@systemeio/ui'
import {
  CreateModuleErrorsInterface,
  CreateModuleInterface,
} from 'modules/courses/courses/curriculum/types/module-interface'
import { CourseId } from 'modules/courses/courses/types/course-interface'
import React, { useState } from 'react'
import CreateModal from 'shared/components/create-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors'
import { AddIcon } from '@systemeio/ui'

const defaultErrors: CreateModuleErrorsInterface = {
  fields: {
    name: '',
  },
}
const defaultValues: CreateModuleInterface = {
  name: '',
}

export interface CreateModuleModalInterface {
  onModuleCreate: (courseId: CourseId, module: CreateModuleInterface) => Promise<void>
  courseId: CourseId
  disabled: boolean
  withIcon?: boolean
}

const CreateModuleModal = ({
  onModuleCreate,
  courseId,
  disabled,
  withIcon = true,
}: CreateModuleModalInterface) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)
  const [errors, setErrors] = useState(defaultErrors)
  const afterLeave = () => {
    setErrors(defaultErrors)
  }
  const onClose = () => setOpened(false)

  const onCreate = async (data: CreateModuleInterface) => {
    await fetchWithFieldErrors(async () => {
      await onModuleCreate(courseId, data)
    }, setErrors)
  }

  return (
    <>
      <PrimaryButton
        disabled={disabled}
        className="flex items-center justify-between"
        onClick={() => setOpened(true)}
        data-test="course-create-module"
      >
        <AddIcon className={`${withIcon ? 'block' : 'lg:hidden'} block`} />
        <span className="whitespace-nowrap">
          {t('dashboard.course.add_module_modal.trigger_title')}
        </span>
      </PrimaryButton>
      <CreateModal
        opened={opened}
        onClose={onClose}
        afterLeave={afterLeave}
        defaultValues={defaultValues}
        caption={t('dashboard.course.module_title')}
        creatable={[
          {
            field: 'name',
            onRender: (value, onChange) => (
              <FormInput
                key={'course-module-create'}
                label={t('global.name')}
                value={value}
                required
                onChange={e => onChange(e.target.value)}
                error={errors.fields.name}
                data-test="course-create-module-name"
              />
            ),
          },
        ]}
        onCreate={onCreate}
        requiredFields={['name']}
        dataTestKey={'course-create-module'}
      />
    </>
  )
}

export default CreateModuleModal
